import { EyeOutlined } from "@ant-design/icons";
import { Button, Flex, Skeleton, Table, TableColumnsType, Tag, Typography } from "antd";
import { useGetSalesOrderDetailV2Query } from "api/sales-order/sales-order-api";
import { OBJ_COLOR } from "commons/constants";
import { numberFormatFractionDigits } from "commons/constants/util";
import useFormToggle from "hooks/useFormToggle";
import { useState } from "react";
import { SalesOrderDetailV2 } from "types/sales-order.type";
import HistoryScaleDrawer from "./HistoryScaleDrawer";

interface SalesOrderDetailTableProps {
	salesOrderId: number;
}

const SalesOrderDetailTableV2 = ({ salesOrderId }: SalesOrderDetailTableProps) => {
	const { open, onOpen, onClose } = useFormToggle();

	const [salesOrderDetailId, setSalesOrderDetailId] = useState<number>(0);

	const { data: dataSalesOrderDetail } = useGetSalesOrderDetailV2Query(salesOrderId, { skip: !salesOrderId, refetchOnMountOrArgChange: true });

	const columns: TableColumnsType<SalesOrderDetailV2> = [
		{
			title: "STT",
			dataIndex: "key",
			ellipsis: true,
		},
		{
			title: "Giới tính",
			dataIndex: "gender",
			ellipsis: true,
		},
		{
			title: "Mã giá",
			dataIndex: "priceListCode",
			ellipsis: true,
		},
		{
			title: "Đơn giá",
			dataIndex: "priceAmount",
			ellipsis: true,

			render: (value: number, record) => `${record.currency} ${numberFormatFractionDigits(value)} ${record.uom}`,
		},
		{
			title: "Số lượng",
			dataIndex: "quantity",
			ellipsis: true,
			render: (value: number) => numberFormatFractionDigits(value),
		},
		{
			title: "Số lượng thực tế",
			dataIndex: "actualQuantity",
			ellipsis: true,
			render: (value: number) => numberFormatFractionDigits(value),
		},
		{
			title: "Trọng lượng thực tế",
			dataIndex: "actualWeight",
			ellipsis: true,
			render: (value: number) => numberFormatFractionDigits(value),
		},
		{
			title: "Thành tiền",
			dataIndex: "totalAmount",
			ellipsis: true,
			render: (value: number) => numberFormatFractionDigits(value),
		},
		{
			title: "Trạng thái",
			dataIndex: "status",
			ellipsis: true,
			fixed: "right",
			render: (value: number) => <Tag color={value === 0 ? "warning" : value === 1 ? "success" : "red"}>{value === 0 ? "Chưa cân" : value === 1 ? "Đã cân" : "Huỷ"}</Tag>,
		},
		{
			dataIndex: "id",
			ellipsis: true,
			fixed: "right",
			render: (id: number) => (
				<Button
					type="text"
					style={{ cursor: "pointer" }}
					onClick={() => {
						setSalesOrderDetailId(id);
						onOpen();
					}}
					icon={<EyeOutlined style={{ color: OBJ_COLOR.SUCCESS }} />}>
					<Typography.Text style={{ color: OBJ_COLOR.SUCCESS }}>Xem chi tiết</Typography.Text>
				</Button>
			),
		},
	];

	return (
		<Skeleton active loading={false}>
			<Table
				columns={columns}
				dataSource={dataSalesOrderDetail?.map((item, key) => ({ ...item, key: key + 1 }))}
				scroll={{ x: true }}
				pagination={false}
				summary={(pageData) => {
					let totalAmount = 0;
					let totalWeight = 0;
					let totalQuantity = 0;

					pageData.forEach((item) => {
						totalAmount += item.totalAmount;
						totalWeight += item.actualWeight;
						totalQuantity += item.actualQuantity;
					});

					return (
						<Table.Summary.Row>
							{/* <Table.Summary.Cell colSpan={10} index={0} className="table-summary-row-cell">
								<Flex justify="space-between" style={{ backgroundColor: "#F7F9FB", padding: 16 }}>
									<Typography.Text strong>Tổng cộng</Typography.Text>
									<Flex gap={30}>
										<Typography.Text strong>SL: {numberFormatFractionDigits(totalQuantity)}</Typography.Text>
										<Typography.Text strong>TL: {numberFormatFractionDigits(totalWeight)} KG</Typography.Text>
										<Typography.Text strong type="success">
											Thành tiền: {numberFormatFractionDigits(totalAmount)} VND
										</Typography.Text>
									</Flex>
								</Flex>
							</Table.Summary.Cell> */}

							<Table.Summary.Cell index={0} colSpan={5} className="table-summary-row-cell">
								<Flex justify="center" style={{ backgroundColor: "#F7F9FB", padding: 16 }}>
									<Typography.Text strong>Tổng cộng</Typography.Text>
								</Flex>
							</Table.Summary.Cell>
							<Table.Summary.Cell index={5} className="table-summary-row-cell">
								<Flex style={{ backgroundColor: "#F7F9FB", padding: 16 }}>
									<Typography.Text strong>{numberFormatFractionDigits(totalQuantity)} CON</Typography.Text>
								</Flex>
							</Table.Summary.Cell>
							<Table.Summary.Cell index={6} className="table-summary-row-cell">
								<Flex style={{ backgroundColor: "#F7F9FB", padding: 16 }}>
									<Typography.Text strong>{numberFormatFractionDigits(totalWeight)} KG</Typography.Text>
								</Flex>
							</Table.Summary.Cell>
							<Table.Summary.Cell index={7} colSpan={3} className="table-summary-row-cell">
								<Flex style={{ backgroundColor: "#F7F9FB", padding: 16 }}>
									<Typography.Text strong style={{ color: OBJ_COLOR.SUCCESS }}>
										{numberFormatFractionDigits(totalAmount)} VND
									</Typography.Text>
								</Flex>
							</Table.Summary.Cell>
						</Table.Summary.Row>
					);
				}}
			/>
			<HistoryScaleDrawer open={open} onClose={onClose} salesOrderId={salesOrderId} salesOrderDetailId={salesOrderDetailId} />
		</Skeleton>
	);
};

export default SalesOrderDetailTableV2;
